import io from "socket.io-client";

const socket = io(import.meta.env.VITE_API_URL || "https://api.cardelivery.app", {
  autoConnect: false,
  transports: ["websocket", "polling"],
  withCredentials: true
});

export default socket;
